import React from 'react';
import '../../sass/main.scss'

const Refunds = () => {
     
 return <>
            <div style={{ backgroundColor:"#fff"}}>
                   <div style={{ padding: "50px"}}>
                      <h3>REKLAMACIJE I POVRAT NOVCA</h3>
                     <h4>Kako izvršiti povrat?</h4>

                     <p>Prema zakonu o zaštiti potrošača potrošač ima pravo da odustane od ugovora sa prodavcem u roku od 14 dana od kada mu je proizvod uručen. Kupac ima pravo da ne obrazlaže razlog raskida ugovora.

U slučaju odustanka od ugovora, potrošač ima pravo na povraćaj novca, ili na zamenu za drugi proizvod. Iznos plaćene robe se kupcu vraća po prijemu proizvoda, i nakon što se utvrdi da je proizvod neoštećen, neotvaran tj.u originalnom pakovanju, nekorišćen i ispravan.</p>
                  <p>Ukoliko niste zadovoljni produktom koji ste dobili i želite da ga vratite, potrebno je kontaktirati broj koji se nalazi na dnu sajta.
                 Povrat robe se vrši tako što na našu adresu šaljete produkt koji je oprezno upakovan kako se ne bi oštetio, uz otkupninu.
                Otkupina je novac koji se Vama vraća a vrijednost otkupnine je tačan iznos koji ste Vi ukupno platili dostavljaču, sa dostavom.  Mi snosimo sve troškove 
                 i dužni smo da Vam isplatimo ukupan iznos koji ste platili.
                  </p>
                  <h4>Oštećeni proizvod</h4>
                  <p>Ukoliko Vam je stigao oštećeni proizvod, možete nas kontaktirati na broj na dnu sajta, također i preko mobilne aplikacije
                      Viber. Potrebno je da uslikate oštećeni proizvod kao dokaz, a zatim ćemo Vam mi zamijeniti za ispravni. Ukoliko nešto nije u redu
                      sa proizvodom, mi snosimo troškove zamijene(kurirska služba). 
                  </p>
                  <h4>Zamijena za drugi proizvod </h4>
                  <p>Ukoliko želite da zamijenite proizvod koji ste dobili za neki drugi sa našeg sajta, sve troškove zamijene snosite Vi.</p>
                   </div>
              </div>

        </>
}

export default Refunds;